import React, { useState } from "react"
import "./App.css"
import "./fonts/Century Gothic.ttf"

import logo from "./assets/inspirits_red.svg"

export default function App() {
  // const [language, setLanguage] = useState("LV")

  // const router = createBrowserRouter([
  //   {
  //     path: "*",
  //     element: (<NotFound />)
  //   },
  //   {
  //     path: "/",
  //     errorElement: <NotFound />,
  //     element: (<Main language={language} />),
  //   },
  //   {
  //     path: "/:title",
  //     errorElement: <NotFound />,
  //     element: <Catrender props={":title"} />

  //   },
  //   {
  //     path: "/News",
  //     errorElement: <NotFound />,
  //     element: (<News/>),
  //   },

  // ])


  return (
    // <CookiesProvider defaultSetCookies={{ path: '/' }}>
    //   <LanguageContext.Provider value={{ language, setLanguage }}>
    //     <RouterProvider router={router} />
    //     <Agreement />
    //     <Footer />
    //   </LanguageContext.Provider>
    // </CookiesProvider>

    <div className="under-construction-container">
      <div className="under-construction-content">
        {/* Icon */}
        <div className="icon-container">
          <img 
            src={logo} 
            alt="Beverage distributor icon" 
            className="beverage-icon"
          />
        </div>
        
        {/* Main heading */}
        <div className="heading-section">
          <h1 className="main-heading">
            Under Construction
          </h1>
          <div className="heading-divider"></div>
        </div>
        
        {/* Content */}
        <div className="content-section">
          <p className="main-description">
            We're working hard to bring you an improved experience.
          </p>
          
        </div>
        
     
      </div>
    </div>
  )
}